// extracted by mini-css-extract-plugin
module.exports = {"lang":"Languages_lang__3AFI3"};